import request from '@/utils/request'

// 本地调试baseURL调整
const baseURL = process.env.VUE_APP_BASE_API

// 新建角色
export function createRole(data) {
  return request({
    url: '/role/create',
    method: 'post',
    data,
    baseURL
  })
}

// 编辑角色
export function editRole(data) {
  return request({
    url: '/role/edit',
    method: 'post',
    data,
    baseURL
  })
}

// 角色权限分类
export function userRoleType(data) {
  return request({
    url: '/approve/roleDataManager/userDataType',
    method: 'post',
    data,
    baseURL
  })
}

// 角色权限查询
export function findUserRole(data) {
  return request({
    url: '/approve/roleDataManager/findByRoleId',
    method: 'post',
    data,
    baseURL
  })
}

// 角色权限查询
export function settingUserRole(data) {
  return request({
    url: '/approve/roleDataManager/assign',
    method: 'post',
    data,
    baseURL
  })
}

// 所有角色查询
export function getRoleList(data) {
  return request({
    url: '/role/queryList',
    method: 'post',
    data,
    baseURL
  })
}

// 所有角色查询
export function getRolePageList(data) {
  return request({
    url: '/role/queryPage',
    method: 'post',
    data,
    baseURL
  })
}

// 删除角色
export function deleteRole(id) {
  return request({
    url: `/role/delete/${id}`,
    method: 'post'
  })
}

// 用于配置人员创建/编辑角色权限页面
export function getUserLimits(data) {
  return request({
    url: '/permission/getRolePermissionTree',
    method: 'post',
    data
  })
}

// 用于配置人员创建/编辑角色权限页面
export function getRolePermission(data) {
  return request({
    url: '/permission/getRolePermission',
    method: 'post',
    data
  })
}

// 查询员工详情列表
export function getUserNameList(data) {
  return request({
    url: '/common/getUserNameList',
    method: 'post',
    data
  })
}

// 分配角色
export function assignUser(data) {
  return request({
    url: '/role/assign',
    method: 'post',
    data
  })
}

// 配置角色权限
export function setRolePermission(data) {
  return request({
    url: '/permission/setRolePermission',
    method: 'post',
    data
  })
}
